import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Merchant } from "./types"; // Adjust import path as needed

interface ViewMerchantModalProps {
    merchant: Merchant;
    onClose: () => void;
}

export default function ViewMerchantModal({ merchant, onClose }: ViewMerchantModalProps): JSX.Element {
    return (
        <Dialog open onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <div className="mb-4">
                    <DialogTitle className="text-lg font-bold">Merchant Details</DialogTitle>
                </div>
                <div className="space-y-2">
                    <p><strong>Merchant ID:</strong> {merchant.merchantId}</p>
                    <p><strong>Merchant Name:</strong> {merchant.merchantName}</p>
                    <p><strong>Mobile Phone:</strong> {merchant.mobilePhone}</p>
                    <p><strong>Email:</strong> {merchant.email || "N/A"}</p>
                    <p><strong>Merchant Code:</strong> {merchant.merchantCode}</p>
                    <p><strong>Address:</strong> {merchant.address || "N/A"}</p>
                    <p><strong>State:</strong> {merchant.state}</p>
                    <p><strong>LGA:</strong> {merchant.lga}</p>
                    <p><strong>Route Name:</strong> {merchant.routeName}</p>
                    <p><strong>Route Code:</strong> {merchant.routeCode}</p>
                    <p><strong>Account Number:</strong> {merchant.accountNumber}</p>
                    <p><strong>Status:</strong> {merchant.isEnabled ? "Active" : "Inactive"}</p>
                    <p><strong>Account Locked:</strong> {merchant.accountLocked ? "Yes" : "No"}</p>
                    <p><strong>Date Created:</strong> {new Date(merchant.dateCreated).toLocaleString()}</p>
                    <p><strong>PTSA:</strong> {merchant.ptsa || "N/A"}</p>
                </div>
            </DialogContent>
        </Dialog>
    );
}